import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientPortalWebNarratives } from "cpl-react-common/components/Enums/ClientPortalWebNarratives";
import { PropsWithChildren, ReactElement } from "react";
import { Link } from "react-router-dom";
import AppBackButton from "./appBackButton/AppBackButton";
import { WebNarrative } from "./webNarrative/WebNarrative";

type PageWrapperProps = {
  title: string;
  extraElements?: ReactElement;
  webNarrativeID?: ClientPortalWebNarratives;
  hideBackButton?: boolean;
  backTo?: string;
  "data-test-id"?: string;
};

const PageWrapper = (props: PropsWithChildren<PageWrapperProps>) => {
  return (
    <div className="cpl-page-container">
      <div className="mb-4">
        {!props.hideBackButton && <AppBackButton backTo={props.backTo} data-test-id={props["data-test-id"]} />}
        <div className="d-flex justify-content-between">
          <h1 className="heading-text my-1">{props.title}</h1>
          {props.extraElements}
        </div>
        {props.webNarrativeID !== undefined && <WebNarrative webNarrativeID={props.webNarrativeID} />}
      </div>
      {props.children}
    </div>
  );
};

type PageCreateButtonProps = {
  to: string;
  text: string;
  "data-test-id"?: string;
};

export const PageCreateButton = (props: PageCreateButtonProps) => {
  return (
    <Link
      className="cpl-btn btn-icon cpl-btn-primary d-flex align-items-center"
      to={props.to}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      data-test-id={props["data-test-id"]}
    >
      <span className="page-create-btn">
        <FontAwesomeIcon icon={faPlus} className="pt-1" />
      </span>
      <span className="ms-2">{props.text}</span>
    </Link>
  );
};

export default PageWrapper;
